// These types are an enum representation of the QueryStatus and FetchStatus type from the query-core library
export enum QueryCoreStatus {
	Error = 'error',
	Loading = 'loading',
	Success = 'success',
}

export enum QueryFetchStatus {
	Fetching = 'fetching',
	Idle = 'idle',
	Paused = 'paused',
}
